import {defineStore} from 'pinia';
import menuConfig from "@/js/menu.ts";

export const usePopupsControlStore = defineStore('popupsControlStore', {
    state: () => ({
        isFormSuccessPopupVisible: false,
        isFormAlreadySentPopupVisible: false,
        isErrorPopupVisible: false,
        isCartSuccessVisible: false,
    }),
    actions: {
        showErrorPopup() {
            this.isErrorPopupVisible = true
        },
        showFormSuccessPopup() {
            this.isFormSuccessPopupVisible = true
        },
        showFormAlreadySendPopup() {
            this.isFormAlreadySentPopupVisible = true
        },
        showCartSuccessPopup() {
            this.isCartSuccessVisible = true
        },
    }
});
